import { useEffect, useState } from "react";
import Masonry from "react-masonry-css";
import { useLocation, useParams } from "react-router-dom";

const TestProject = () => {

    const SERVER_URL = process.env.NODE_ENV === 'development' ?
        process.env.REACT_APP_DEV_SERVER_URL : process.env.REACT_APP_PROD_SERVER_URL;

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [project, setProject] = useState(null);

    const location = useLocation();
    const { id } = useParams();


    const fetchProjectData = async () => {
        if (location.state != null &&
            location.state.project != null &&
            location.state.project != undefined) {

            setProject(location.state.project);
            setLoading(false);
        } else if (id) {
            let result = await fetch(`${SERVER_URL}/project/${id}`, {
                method: 'GET',
                // signal: abortController.signal
            });
            if (result == null) {
                return <h3>Oops, the project you are looking for does not exist...</h3>
            }
            result = await result.json();
            setLoading(false);
            setProject(result);
            return result;
        } else {
            setLoading(false);
            return <h3>Oops, the project you are looking for does not exist...</h3>
        }
    }

    const fetchProjectDataPromise = () => {
        if (location.state != null &&
            location.state.project != null &&
            location.state.project != undefined) {

            setProject(location.state.project);
            setLoading(false);
        } else if (id) {
            fetch(`${SERVER_URL}/project/${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
                // signal: abortController.signal
            })
                .then((response) => {
                    return response.json();
                }).then((data) => {
                    setLoading(false);
                    // console.log('data: ' + JSON.stringify(data));
                    if (data.error) {
                        setError(true);
                        return false;
                    }
                    setProject(data);
                    return data;
                });
        } else {
            setLoading(false);
            return false;
        }
    }

    const breakpointColumnsObj = {
        default: 3,
        1200: 3,
        992: 2,
        576: 1
    };

    useEffect(() => {
        if (window.scrollY != 0) {
            //user scrolled to the top of the page
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
        // const abortController = new AbortController();
        fetchProjectDataPromise();
        // return () => abortController.abort();
    }, []);

    let errorContent =
        <div className="p-5">
            <h3 className="chocolate">Oops, the project you are looking for does not exist...</h3>
        </div>
    let loadingContent =
        <div className="p-5">
            <h3 className="chocolate">Loading...</h3>
        </div>;

    return (
        <div>
            {loading && loadingContent}
            {error && errorContent}
            {project &&
                <div className="container project">
                    {/* Start - Main Section Banner Image and Description */}
                    <div className="banner d-flex justify-content-center pt-5">
                        <img src={project.bannerImageFirebaseRef} alt="jeevandeep" />
                    </div>
                    <div className="project-content py-5">
                        <div className="heading-3 chocolate">
                            {project.projectName}
                        </div>
                        <div id="project-location" className="heading-1 chocolate">
                            {project.location}
                        </div>
                        <div className="row py-4 justify-content-between">
                            <div className="col-6 px-3">
                                <div className="description">
                                    <figcaption className="img-caption content-0 chocolate">
                                        about the project:
                                    </figcaption>
                                    <p className="content-1 chocolate">
                                        {project.description}
                                    </p>
                                </div>
                            </div>
                            {/* <div className="col-4 px-3">
         <div id="project-details">
             <p className="content-0">Client: Uday Somani</p>
             <p className="content-0">Size: 600 sq.ft.</p>
             <p className="content-0">Completed in: 2023</p>
             <p className="content-0">Awards: Mh best</p>
         </div>
     </div> */}
                        </div>
                        {/* End - Main Section Banner Image and Description */}

                        { /* Start - Masonry Grid for site images */}
                        <div id='project-masonry'>
                            <Masonry
                                breakpointCols={breakpointColumnsObj}
                                className="my-masonry-grid"
                                columnClassName="my-masonry-grid_column"
                            >
                                {
                                    project.projectImagesFirebaseRef.length > 0 &&
                                    project.projectImagesFirebaseRef.map(
                                        (item, index) =>
                                            <div className="masonry-grid-item" key={index}>
                                                <img loading="lazy" className="img-fluid gallery-project-image" src={item} alt="" />
                                            </div>
                                    )
                                }
                            </Masonry>
                        </div>
                        { /* End - Masonry Grid for site images */}
                    </div>
                </div>
            }
        </div >
    );
}

export default TestProject;